import { AxiosInstance } from "axios"
import { ServiceResponse } from "../../../../core/api/apiTypes"
import { PaymentLink, PaymentLinkDetails, PaymentLinkItem } from "./paymentLinksTypes"

export enum PaymentLinksQuery {
    LIST = "payment-links-for-merchant",
    DETAILS = "payment-link-for-merchant",
}

type PaymentLinksParams = Readonly<{
    merchantId: number
}>

export type PaymentLinksResponse = {
    paymentLinks: PaymentLink[]
}

export async function fetchPaymentLinks(
    { merchantId }: PaymentLinksParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<PaymentLinksResponse> {
    const url = `/merchants/${merchantId}/paymentLinks`

    const response = await axios.get(url, {
        params: {},
        signal,
    })

    return response.data
}

type DeletePaymentLinkParams = Readonly<{
    paymentLinksId: number
}>

export async function deletePaymentLink(
    { paymentLinksId }: DeletePaymentLinkParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.delete(`/paymentLinks/${paymentLinksId}`, {
        signal,
    })
    return data
}

type PaymentLinkDetailsParam = Readonly<{
    paymentLinksId: string
}>

export type PaymentLinkDetailsResponse = Readonly<{
    paymentLink: PaymentLinkDetails
}>

export async function paymentLinkDetails(
    { paymentLinksId }: PaymentLinkDetailsParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<PaymentLinkDetailsResponse> {
    const url = `/paymentLinks/${paymentLinksId}`

    const { data } = await axios.get(url, {
        signal,
    })

    return data
}

type CreatePaymentLinkParam = Readonly<{
    paymentLink: PaymentLinkItem
}>

export async function createPaymentLink(
    { paymentLink }: CreatePaymentLinkParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/paymentLinks`,
        {
            paymentLink,
        },
        {
            signal,
        },
    )
    return data
}

type UpdatePaymentLinkParam = Readonly<{
    paymentLinksId: string
    paymentLink: PaymentLinkItem
}>

export async function updatePaymentLink(
    { paymentLinksId, paymentLink }: UpdatePaymentLinkParam,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<ServiceResponse<{}>> {
    const { data } = await axios.post(
        `/paymentLinks/${paymentLinksId}`,
        {
            paymentLink,
        },
        {
            signal,
        },
    )
    return data
}
